import type { Dispatch, SetStateAction } from 'react';
import privacyPolicyEnglish from '../../assets/documents/home/footer/Privacy_policy.pdf';
import privacyPolicyCroatian from '../../assets/documents/home/footer/Privacy_policy_HR.pdf';
import Variables from '../../style/variables.scss';
import Modal from '../04_ modal/Modal';

const PrivacyPolicyModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: Dispatch<SetStateAction<boolean>>;
}) => {
  const closeModal = () => {
    onClose(false);
  };

  return (
    <Modal
      id='privacy_policy_modal'
      isOpen={isOpen}
      onClose={onClose}
      primaryColor={Variables.primaryColor}
      secondaryColor={Variables.secondaryColor}
    >
      <div className='privacy_policy_modal'>
        <div className='privacy_policy_modal_content'>
          <h2>Privacy policy</h2>
          <p>Choose your language / Odaberite jezik</p>
          <div className='privacy_policy_modal_buttons'>
            <a
              href={privacyPolicyEnglish}
              target='_blank'
              rel='noreferrer'
              className='opacity_transition_low'
              onClick={closeModal}
            >
              <div>ENGLISH</div>
            </a>
            <a
              href={privacyPolicyCroatian}
              target='_blank'
              rel='noreferrer'
              className='opacity_transition_low privacy_policy_modal_buttons_croatian'
              onClick={closeModal}
            >
              <div>HRVATSKI</div>
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PrivacyPolicyModal;
